import { InMemoryCache, from } from '@apollo/client'
import { ApolloClient } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import {
  OAuth2RefreshDocument,
  OAuth2RefreshMutationResult
} from 'graph/generated/payments/graphql-types'
import { GraphQLError } from 'graphql'
import Cookies from 'js-cookie'
import { handleSSRErrors, httpLink } from 'utils/apollo'
import { AppCookie, cookieOptions } from 'utils/cookies'

/* SSR shares cache in server so we never wanna use it */
const refreshSSRClient = new ApolloClient({
  link: from([onError(errors => handleSSRErrors(errors)), httpLink]),
  cache: new InMemoryCache(),
  ssrMode: true,
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
      fetchPolicy: 'no-cache'
    },
    query: {
      errorPolicy: 'all',
      fetchPolicy: 'no-cache'
    },
    mutate: {
      fetchPolicy: 'no-cache'
    }
  }
})

export const oauth2RefreshPayments = async () => {
  try {
    const refreshToken = Cookies.get(AppCookie.RefreshCustomer)

    if (!refreshToken) {
      throw new GraphQLError('Missing refresh token')
    }

    const { data }: Pick<OAuth2RefreshMutationResult, 'data'> =
      await refreshSSRClient.mutate({
        mutation: OAuth2RefreshDocument,
        variables: {
          refreshToken
        },
        context: {
          headers: {
            'X-Origin': process.env.NEXT_PUBLIC_PORTAL_DOMAIN ?? ''
          }
        }
      })

    if (!data?.OAuth2Refresh?.id_token || !data?.OAuth2Refresh?.refresh_token) {
      throw new GraphQLError('Invalid token response')
    }

    Cookies.set(
      AppCookie.TokenCustomer,
      data?.OAuth2Refresh?.id_token,
      cookieOptions(AppCookie.TokenCustomer, { httpOnly: false })
    )

    Cookies.set(
      AppCookie.IdTokenHintCustomer,
      data?.OAuth2Refresh?.id_token,
      cookieOptions(AppCookie.IdTokenHintCustomer, { httpOnly: false })
    )

    Cookies.set(
      AppCookie.RefreshCustomer,
      data?.OAuth2Refresh?.refresh_token,
      cookieOptions(AppCookie.RefreshCustomer, { httpOnly: false })
    )

    const customerId = Cookies.get(AppCookie.CustomerId)

    if (!customerId) {
      throw new GraphQLError('Missing customerId')
    }

    Cookies.set(
      AppCookie.CustomerId,
      customerId,
      cookieOptions(AppCookie.CustomerId, { httpOnly: false })
    )
  } catch (err) {
    throw new GraphQLError(err)
  }
}
